/* istanbul ignore file */
export { default } from './FlexiLeaseForm';
